const vi = {
    homeTitle: 'Trang chủ',
    menuCategory: 'Mua sắm',
    menuSales: 'Sale',
    menuSaved: 'Đã lưu',
    login: {
        title: 'Chào bạn!',
        forgotPassWord: 'Quên mật khẩu?',
        register: 'Đăng ký ngay',
        haveAccount: 'Bạn đã có tài khoản? Đăng nhập ngay!',
        haveNotAccount: 'Bạn chưa có tài khoản? Đăng ký ngay',
        existedEmail: 'Email đã tồn tại',
        existedPhone: 'Số điện thoại đã tồn tại',
        nameRequired: 'Tên là bắt buộc',
        emailRequired: 'Email là bắt buộc',
        phoneRequired: 'Số điện thoại là bắt buộc',
        loginTitle: 'Hãy điền vào biểu mẫu sau để đăng nhập với Billion Girl',
        registerTitle: 'Hãy điền vào biểu mẫu sau để đăng ký với Billion Girl',
        registerTitleSub:
            'Chúng tôi sẽ lưu thông tin chi tiết quý khách cung cấp để hỗ trợ giao dịch của quý khách trên website của chúng tôi',
        registerNote:
            '(*) Lưu ý: Nếu quý khách đã là thành viên của BILLION GIRL, vui lòng nhập số điện thoại tích điểm để đồng bộ thông tin mua sắm',
        txtLogin: 'Đăng nhập',
        txtRegister: 'Đăng ký',
        wrongOTP: 'Sai mã OTP. Vui lòng kiểm tra và nhập lại!',
        sentOTP: 'Mã OTP đã được gửi đến số điện thoại: {{phone}}.',
        enterOTP: 'Vui lòng kiểm tra và nhập vào mã OTP',
        verifyInformation: 'Xác minh số điện thoại ({{timeOut}})',
        verifyOTP: 'Xác minh mã OTP',
        btnResend: 'Gửi lại ({{timeOut}})',
        btnVerify: 'Xác minh',
        msgOTPInvalid: 'Mã OTP không hợp lệ. Vui lòng thử lại.',
        msgOTPExpired: 'Mã OTP đã hết hạn. Vui lòng gửi lại mã xác minh để thử lại.',
        msgOTPTooManyRequest: 'Bạn đã yêu cầu quá nhiều lần, vui lòng xóa cache và thử lại sau.'
    },
    reset: {
        changePasswordFailed: 'Đổi mật khẩu thất bại'
    },
    notFound: {
        header: 'Không tìm thấy trang',
        title: 'Không tìm thấy trang',
        subTitle:
            'Hiện tại không thể tìm thấy trang bạn yêu cầu. Chúng tôi xin lỗi về sự bất tiện này, mong bạn vui lòng thử lại sau!'
    },
    about: {
        title_1: 'Beyond the SEXY',
        title_2: 'Beyond the BEAUTY',
        content_1:
            'Mang đến sự trải nghiệm quyến rũ cho khách hàng tạo nên từ những chất liệu cao cấp, với độ co giãn và đàn hồi ưu việt, không mất form sau nhiều lần sử dụng.',
        content_2:
            ' Quyến rũ, hiện đại, phóng khoáng nhưng không chỉ có vậy. Tôn vinh vẻ đẹp của phụ nữ bởi những thiết kế nhấn mạnh vào sự sang trọng, tinh tế, cùng sự gia công tỉ mẫn của đội ngũ Billion Girl.'
    },
    cart: {
        bag: 'Giỏ hàng',
        totalBags: 'Tổng số sản phẩm: {{total}}',
        product: 'Sản phẩm',
        desc: 'Mô tả',
        unit: 'Số lượng',
        price: 'Số tiền',
        outOfStockNote:
            '(*) Giỏ hàng của bạn có sản phẩm đã hết hàng. Vui lòng xóa sản phẩm hoặc tiếp tục thanh toán mà không có sản phẩm đã hết hàng'
    },
    contact: {
        title: 'Liên hệ',
        online: 'Trực tuyến từ 8:00 sáng - 17:00 | Thứ 2 - Thứ 7',
        contact:
            'Gửi thông tin về hộp thư của Billion Girl để được giải đáp & xử lý các vấn đề liên quan',
        address:
            'HCM: 780/10 Sư Vạn Hạnh P12 Q10 | HN: Lầu 3 , 82 Nguyễn Lương Bằng , Đống Đa , Hà Nội',
        openTime: 'Mở cửa: 09:30 - 21:30 | Các ngày trong tuần',
        reason: 'Lý do liên hệ',
        msgReason: 'Lý do không được để trống',
        name: 'Tên của bạn',
        msgName: 'Tên không được để trống',
        email: 'Địa chỉ email',
        orderNumber: 'Mã order',
        content: 'Lời nhắn',
        msgContent: 'Lời nhắn không được để trống',
        msgSendMessageSuccess: 'Gửi phản hồi thành công',
        msgSendMessageFailed: 'Gửi phản hồi thất bại'
    },
    home: {
        feature: 'Feature Product',
        collection: 'Shop the collection'
    },
    wish: {
        title: 'Đã lưu',
        price: 'Số tiền',
        select: 'Xem chi tiết',
        product: 'Sản phẩm',
        description: 'Mô tả'
    },
    filter: {
        title: 'Lọc',
        color: 'Màu sắc',
        size: 'Size',
        styles: 'Category',
        price: 'Giá tiền',
        apply: 'Áp dụng',
        clear: 'Đặt lại'
    },
    orderSummary: {
        shippingFee: 'Phí giao hàng',
        price: 'Giá',
        discount: 'Giảm giá',
        select: 'Xem chi tiết',
        product: 'Sản phẩm',
        desc: 'Mô tả',
        unit: 'Số lượng',
        size: 'Size',
        standardShipping: 'Giao hàng tiêu chuẩn',
        deliveryFeeNote:
            '(*) Chưa bao gồm mức phí cho dịch vụ giao hàng là 30.000 đồng cho tất cả khu vực (Riêng khách Diamond sẽ là miễn phí).',
        customer: 'Khách hàng',
        receiver: 'Người nhận'
    },
    header: {
        langEN: 'Tiếng Anh',
        langVN: 'Tiếng Việt',
        userProfile: 'Thông Tin Tài Khoản',
        orderHistory: 'Lịch Sử Mua Hàng',
        management: 'Trang Quản Lý',
        changePassword: 'Đổi Mật Khẩu',
        logOut: 'Đăng Xuất',
        search: 'Tìm kiếm ...',
        menuCategory: 'MUA SẮM',
        menuSales: 'SALE',
        subMenuSale: 'Sản phẩm sale',
        menuContact: 'THÔNG TIN',
        menuAbout: 'CHÚNG TÔI',
        cartEmpty: 'Không có sản phẩm',
        shopping: 'Bắt đầu mua sắm',
        viewCart: 'Xem giỏ hàng',
        cart: 'Giỏ hàng: {{total}}',
        total: 'Tổng cộng: {{total}}',
        noSale: 'Không có sản phẩm giảm giá',
        allProduct: 'Tất cả sản phẩm',
        noSaleProduct: 'Không có sản phẩm'
    },
    footer: {
        followTitle: 'THEO DÕI CHÚNG TÔI TRÊN NHÓM FACEBOOK ĐỂ BIẾT THÊM NHIỀU ƯU ĐÃI HẤP DẪN',
        subscribe: "Let's be a BillionGirl Member",
        btnSubscribe: 'Theo Dõi',
        about: 'Giới thiệu về chúng tôi',
        store: 'Cửa hàng',
        contact: 'Liên hệ',
        policy: 'Chính sách',
        subscribeSuccess: 'Đăng ký thành công',
        shippingPolicy: 'Chính sách giao hàng',
        returnPolicy: 'Chính sách đổi hàng',
        deliveryPolicy: 'Chính sách vận chuyển',
        securityPolicy: 'Chính sách bảo mật dữ liệu',
        information: 'Hướng dẫn mua hàng',
        shoppingGuide: 'Cách mua hàng',
        payment: 'Thanh toán',
        returnProduct: 'Quy trình và cách thức đổi hàng',
        askQuestions: 'Câu hỏi thường gặp',
        delivery: 'Giao hàng',
        headerStore: 'CỬA HÀNG',
        headerShoppingGuide: 'CÁCH MUA HÀNG',
        headerPayment: 'THANH TOÁN',
        headerDelivery: 'GIAO HÀNG',
        headerQuestion: 'NHỮNG CÂU HỎI THƯỜNG GẶP',
        headerReturnPolicy: 'CHÍNH SÁCH ĐỔI HÀNG',
        headerReturnProcess: 'QUY TRÌNH VÀ CÁCH THỨC ĐỔI HÀNG CHO KHÁCH',
        headerSecurity: 'CHÍNH SÁCH BẢO MẬT DỮ LIỆU',
        headerDeliveryPolicy: 'CHÍNH SÁCH VẬN CHUYỂN',
        headerRewardPolicy: 'CÁCH TÍCH LŨY ĐIỂM THƯỞNG'
    },
    profile: {
        name: 'Tên',
        phone: 'Số điện thoại',
        province: 'Tỉnh/ Thành phố',
        ward: 'Phường/ Xã',
        role: 'Chức danh',
        email: 'Email',
        birthday: 'Ngày sinh',
        district: 'Quận/ Huyện',
        address: 'Địa chỉ chi tiết',
        holderCity: 'Chọn Tỉnh/ Thành phố',
        holderDistrict: 'Chọn Quận/ Huyện',
        tittle: 'Tài khoản của tôi',
        detail: 'Thông tin cá nhân chi tiết',
        updateDetail: 'Cập nhật thông tin cá nhân chi tiết',
        history: 'Lịch sử mua sắm',
        orderHistory: 'Lịch sử đặt hàng',
        invoiceHistory: 'Lịch sử mua hàng',
        returnHistory: 'Lịch sử trả hàng',
        reward: 'Cách tích lũy điểm thưởng',
        memberCard: 'Standard',
        memberCardGold: 'Gold',
        memberCardDiamond: 'Diamond',
        updateInfo:
            'Quý khách có thể truy cập và sửa đổi thông tin chi tiết cá nhân (tên, địa chỉ thanh toán, số điện thoại v..v..) để tạo điều kiện cho quá trình mua hàng của quý khách trong tương lai và thông báo cho chúng tôi về bất kì thay đổi nào trong thông tin liên hệ',
        updateEmail: 'Cập nhật địa chỉ email',
        updateEmailAlert:
            'Nếu Quý khách muốn cập nhật địa chỉ email được liên kết với tài khoản này, vui lòng điền các thông tin sau. Yêu cầu mật khẩu vì lý do bảo mật',
        updateAddress: ' Cập nhật địa chỉ',
        updateAddressAlert:
            'Nếu Quý khách muốn cập nhật địa chỉ, vui lòng cung cấp những thông tin sau',
        member: 'Thành viên: {{name}}',
        rewardPoint: 'Điểm hiện tại: {{point}}',
        btnSyncPoint: 'Đồng bộ điểm',
        msgSyncSuccess: 'Đồng bộ thông tin thành công',
        msgSyncFailed: 'Đồng bộ thông tin thất bại',
        msgUpdateSuccess: 'Cập nhật thông tin cá nhân thành công',
        msgUpdateFailed: 'Cập nhật thông tin cá nhân thất bại',
        msgUpdateEmailSuccess: 'Cập nhật email thành công',
        msgUpdateEmailFailed: 'Cập nhật email thất bại',
        txtPasswordRequired: 'Yêu cầu mật khẩu',
        holderBirthday: 'Chọn ngày sinh',
        currentCart: 'Bạn đang là thẻ {{card}}',
        standardPromotion: 'Hãy tận hưởng mua sắm với thẻ Standard',
        goldPromotion: 'Hãy tận hưởng {{ratio}}% giảm giá với thẻ Gold',
        diamondPromotion: 'Hãy tận hưởng {{ratio}}% giảm giá với thẻ Diamond',
        extraPhoneNote:
            'Số điện thoại là thông tin tích điểm. Vui lòng liên hệ trực tiếp với BILLIONGIRL để thay đổi.',
        extraBirthdayNote:
            'Vui lòng liên hệ với BILLIONGIRL thay đổi thông tin ngày sinh để nhận được ưu đãi trong tháng sinh nhật.',
        totalPrice: 'Tổng mua: {{totalPrice}}',
        totalReturn: 'Tổng trả hàng: {{totalPrice}}',
        subscribe: 'Theo dõi',
        unsubscribe: 'Hủy theo dõi',
        height: 'Chiều cao',
        weight: 'Cân nặng',
        loyaltySyncNote: 'Điểm tích lũy của bạn thường sẽ được đồng bộ trong vòng 24h, nếu bạn muốn đồng bộ sớm hơn, hãy liên hệ với chăm sóc khách hàng của chúng tôi'
    },
    order: {
        user: 'Khách hàng',
        phone: 'Số điện thoại',
        price: 'Giá tiền',
        shippingAddress: 'Địa chỉ giao hàng',
        paymentMethod: 'Phương thức thanh toán',
        deliveryMethod: 'Phương thức giao hàng',
        status: 'Trạng thái đơn hàng',
        note: 'Ghi chú',
        msgName: 'Tên không được để trống',
        msgPrice: 'Giá không được để trống',
        msgPhone: 'Số điện thoại không được để trống',
        msgShipping: 'Địa chỉ giao hàng không được để trống',
        msgPayment: 'Phương thức thanh toán không được để trống',
        msgDelivery: 'Phương thức giao hàng không được để trống',
        msgStatus: 'Trạng thái đơn hàng không được để trống',
        msgAddress: 'Địa chỉ không được để trống',
        shippingFee: 'Phí ship',
        totalPrice: 'Thành tiền',
        orderDate: 'Ngày đặt hàng',
        shippingDate: 'Ngày ship hàng',
        btnAction: 'Thao tác',
        image: 'Hình ảnh',
        color: 'Màu sắc',
        size: 'Size',
        discount: 'Giảm giá',
        quantity: 'Số lượng',
        name: 'Tên sản phẩm',
        totalItemPrice: 'Tổng tiền sản phẩm',
        saleOff: 'Giảm giá',
        membershipDiscount: 'Giảm giá thành viên',
        totalOrder: 'Tổng giá trị đơn hàng',
        holderSearch: 'Tìm kiếm theo mã đặt hàng, mã khách hàng hoặc tên khách hàng',
        orderHistory: 'Lịch sử mua hàng',
        holderInvoiceSearch: 'Tìm kiếm theo mã hóa đơn, mã khách hàng, tên khách hàng',
        orderCode: 'Mã đặt hàng',
        purchaseDate: 'Ngày thanh toán',
        total: 'Khách cần trả',
        totalPayment: 'Cần thanh toán',
        statusValue: 'Trạng thái',
        financialStatus: 'Trạng thái thanh toán',
        carrierStatus: 'Trạng thái giao hàng',
        orderID: 'ID đặt hàng',
        description: 'Mô tả',
        discountOrder: 'Giảm giá',
        orderStatus: {
            temporary: 'Phiếu tạm',
            inDelivery: 'Đang giao hàng',
            finished: 'Hoàn thành',
            cancelled: 'Đã hủy',
            confirmed: 'Đã xác nhận'
        },
        orderFinancialStatus: {
            pending: 'Chờ xử lý',
            authorized: 'Đã xác thực',
            partially_paid: 'Thanh toán một phần',
            paid: 'Đã thanh toán',
            partially_refunded: 'Nhập trả một phần',
            refunded: 'Đã nhập trả',
            voided: 'Rỗng'
        }
    },
    invoice: {
        totalProduct: 'Số lượng sản phẩm',
        totalItemPrice: 'Tổng tiền hàng',
        discount: 'Giảm giá',
        discountInvoice: 'Giảm giá hóa đơn ({{discount}}%):',
        deliveryFee: 'Vận chuyển',
        total: 'Tổng giá trị đơn hàng',
        totalPayment: 'Đã thanh toán',
        paymentInfo: 'Thông tin thanh toán',
        paymentMethod: 'Phương thức thanh toán',
        paymentPrice: 'Số tiền thanh toán',
        paymentDate: 'Ngày thanh toán',
        paymentStatus: 'Trạng thái thanh toán',
        note: 'Ghi chú',
        deliveryCode: 'Mã vận đơn',
        receiver: 'Người nhận',
        customerName: 'Khách hàng',
        invoiceID: 'ID',
        invoiceCode: 'Mã hóa đơn',
        customerId: 'ID khách hàng',
        customerCode: 'Mã khách hàng',
        status: 'Trạng thái',
        description: 'Mô tả',
        discountRatio: 'Giảm giá (%)',
        invoiceStatus: {
            finished: 'Hoàn thành',
            cancelled: 'Đã hủy',
            processing: 'Đang xử lý',
            canNotDelivery: 'Không giao được'
        }
    },
    return: {
        code: 'Mã trả hàng',
        invoiceId: 'Mã hóa đơn',
        returnDate: 'Ngày trả hàng',
        returnTotal: 'Cần trả khách',
        totalPayment: 'Đã trả khách',
        statusValue: 'Trạng thái',
        returnDiscount: 'Giảm giá phiếu trả',
        returnFee: 'Phí trả hàng',
        description: 'Mô tả',
        total: 'Tổng số lượng',
        searchHolder: 'Tìm kiếm theo mã trả hàng, mã khách hàng, tên khách hàng',
        totalPrice: 'Tổng tiền trả hàng',
        returnStatus: {
            finished: 'Đã trả',
            cancelled: 'Đã hủy'
        }
    },
    productEntity: {
        name: 'Tên',
        color: 'Màu',
        discount: 'Giảm giá',
        discountPercent: 'Phần trăm giảm',
        discountValue: 'Giảm giá tiền',
        description: 'Mô tả',
        titleEditColor: 'Cập nhật màu',
        titleCreateColor: 'Tạo mới màu',
        holderSearchColor: 'Tìm kiếm theo tên',
        titleEditCategory: 'Cập nhật Category',
        titleCreateCategory: 'Tạo mới category',
        titleEditDiscount: 'Cập nhật mã giảm giá',
        titleCreateDiscount: 'Tạo mã giảm giá',
        titleEditSize: 'Cập nhật Size',
        titleCreateSize: 'Tạo mới Size',
        msgName: 'Tên không được để trống',
        msgDescription: 'Mô tả không được để trống',
        msgColor: 'Màu không được để trống',
        msgImage: 'Hình ảnh không được để trống',
        msgDiscount: 'Mã giảm giá không được để trống',
        image: 'Hình ảnh',
        imageChange: 'Thay đổi ảnh',
        isActive: 'Trạng thái',
        withMember: 'Kết hợp Membership',
        active: 'Hoạt động',
        deActive: 'Không hoạt động',
        msgUpdateSuccess: 'Cập nhật thành công',
        msgDeleteSuccess: 'Xóa thành công',
        isDisplay: 'Hiển thị trang chủ',
        cover: 'Ảnh bìa',
        url: 'Đường dẫn',
        bankName: 'Chủ khoản',
        accountNumber: 'Số tài khoản',
        msgUpdateSaleCover: 'Cập nhật ảnh bìa thành công',
        saleCover: 'Ảnh bìa trang Sale',
        productDisplay: 'Cài đặt sản phẩm hiển thị',
        categoryDisplay: 'Cài đặt category hiển thị',
        msgWarningCanNotDelete: 'Không thể xóa!',
        msgProductAssociated: 'Thông tin này đang được liên kết với các sản phẩm dưới đây. Vui lòng gỡ bỏ liên kết trước khi xóa!'
    },
    layout: {
        title: 'Tiêu đề chính',
        subTitle: 'Tiêu đề phụ',
        position: 'Vị trí tiêu đề',
        coverImage: 'Nền',
        msgNameRequired: 'Tên không được để trống',
        holderSearch: 'Tìm kiếm theo tên, tiêu đề chính hoặc tiêu đề phụ',
        status: 'Trạng thái',
        msgUpdateSuccess: 'Cập nhật layout thành công',
        msgUpdateFailed: 'Cập nhật layout thất bại',
        display: 'Hiển thị',
        useVideo: 'Sử dụng video',
        name: 'Tên'
    },
    collection: {
        relativeProduct: 'Sản phẩm liên quan',
        holderSearch: 'Tìm kiếm theo tên',
        name: 'Tên',
        presentImage: 'Ảnh đại diện',
        collectionImage: 'Ảnh trong bộ sưu tập',
        description: 'Mô tả',
        msgName: 'Tên không được để trống!',
        msgDescription: 'Mô tả không được để trống!',
        msgRelativeProduct: 'Sản phẩm liên quan không được để trống!',
        msgPresentImage: 'Ảnh đại diện không được để trống!',
        msgCollectionImage: 'Ảnh bộ sưu tập không được để trống!'
    },
    history: {
        entityId: 'ID ghi log',
        entity: 'Bản ghi log',
        action: 'Thao tác',
        author: 'Người cập nhật',
        newValue: 'Giá trị đã cập nhật',
        oldValue: 'Giá trị cũ',
        updateDate: 'Ngày cập nhật',
        holderSearch: 'Tìm kiếm theo tên'
    },
    follower: {
        status: 'Trạng thái',
        active: 'Hoạt động',
        deActive: 'Không hoạt động',
        email: 'Email',
        holderSearch: 'Tìm kiếm người theo dõi theo tên',
        msgEmail: 'Email không được để trống!',
        header: 'Chỉnh sửa người theo dõi',
        createdDate: 'Ngày đăng ký'
    },
    payment: {
        deliveryMethod: 'Thông tin giao hàng',
        paymentMethod: 'Phương thức thanh toán',
        shippingMethod: 'Chính sách đổi hàng và vận chuyển hàng',
        shippingInfo: 'Thông tin giao hàng',
        productList: 'Danh sách sản phẩm',
        orderDetail: 'Chi tiết đơn hàng',
        confirmOrder: 'Xác nhận đơn hàng',
        noProduct: '(*) Giỏ hàng của quý khách không có sản phẩm. Vui lòng trở về',
        overInventory: 'Giỏ hàng của bạn chứa sản phẩm đã hết hàng, hoặc quá số lượng có thể đặt. Vui lòng kiểm tra lại thông tin sản phẩm.',
        productName: 'Sản phẩm',
        available: 'Khả dụng',
        ordered: 'Đã đặt',
        editCart: 'Cập nhật giỏ hàng'
    },
    paymentResult: {
        msgOrderSuccess: 'Thanh toán thành công',
        msgContact: 'Billion Girl sẽ liên hệ với bạn trong vòng 24 giờ tới',
        msgOrderFail: 'Đã có lỗi xảy ra trong quá trình đặt hàng!',
        msgSorry: 'Billion Girl rất xin lỗi vì trãi nghiệm không tốt này',
        msgReContact:
            'Vui lòng thực hiện lại giao dịch hoặc liên hệ trực tiếp với chúng tôi qua hotline: 0901235238',
        orderCode: 'Mã đơn hàng của bạn là: {{code}}',
        thanks: 'Cảm ơn đã mua sắm cùng Billion Girl'
    },
    product: {
        productCode: 'Mã hàng',
        productName: 'Tên sản phẩm',
        quantity: 'Số lượng',
        price: 'Đơn giá',
        discount: 'Giảm giá',
        sellPrice: 'Giá bán',
        availableQuantity: 'Khả dụng',
        inventory: 'Tồn',
        finalPrice: 'Thành tiền',
        active: 'Đang kinh doanh',
        deActive: 'Ngừng kinh doanh',
        displayHomepage: 'Hiển thị trang chủ',
        placeHolderSearchProduct: 'Tìm kiếm theo tên sản phẩm, code',
        msgSyncSuccess: 'Đồng bộ dữ liệu thành công',
        msgSyncFailed: 'Đồng bộ dữ liệu thất bại',
        msgDeleteSuccess: 'Xóa dữ liệu thành công',
        msgDeleteFailed: 'Xóa dữ liệu thất bại',
        name: 'Tên sản phẩm',
        description: 'Mô tả sản phẩm',
        descriptionEn: 'Mô tả sản phẩm (EN)',
        image: 'Hình ảnh',
        color: 'Màu sắc',
        size: 'Size',
        category: 'Category',
        optionImage: 'Ảnh mở rộng',
        msgName: 'Tên sản phẩm không được để trống',
        msgPrice: 'Giá không được để trống',
        msgQuantity: 'Số lượng không được để trống',
        msgDescription: 'Mô tả không được để trống',
        msgImage: 'Hình ảnh không được để trống',
        msgColor: 'Màu sắc không được để trống',
        msgSize: 'Size không được để trống',
        msgCategory: 'Category không được để trống',
        msgOptionImage: 'Ảnh mở rộng không được để trống',
        holderColor: 'Chọn màu',
        holderSize: 'Chọn size',
        holderCategory: 'Chọn category',
        holderSizeGuide: 'Chọn size guide',
        holderDiscount: 'Chọn mã giảm giá',
        imageChange: 'Thay đổi ảnh',
        btnNew: 'Tạo mới',
        btnAction: 'Thao tác',
        msgDelete: 'Bạn có chắc muốn xóa sản phẩm này không?',
        sizeGuide: 'Hướng dẫn chọn size',
        relativeProducts: 'Sản phẩm cùng loại',
        linkProducts: 'Liên kết sản phẩm',
        holderRelativeProducts: 'Vui lòng chọn sản phẩm cùng mẫu, khác size',
        holderLinkedProducts: 'Vui lòng chọn sản phẩm liên kết',
        msgDisplayProduct: 'Bạn có muốn hiển thị sản phẩm lên trang bán hàng?',
        display: 'Hiển thị',
        discountByNumber: 'Giảm giá theo số lượng',
        discountNumber: 'Số lượng giảm giá',
        productId: 'ID',
        customColumnDisplay: 'Chọn cột hiển thị',
        status: 'Trạng thái',
        onHand: 'Tồn kho',
        reserved: 'Đặt',
        remainCanBuy: '* Sản phẩm còn lại: {{quantity}}',
        purchaseStatus: 'Trạng thái kinh doanh',
        noProductFound: 'Không tìm thấy sản phẩm phù hợp'
    },
    customer: {
        memberShip: 'Thành viên',
        totalRevenue: 'Tổng tiền đã mua',
        totalInvoice: 'Tổng đơn hàng',
        dept: 'Nợ hiện tại',
        phone: 'Số điện thoại',
        email: 'Email',
        customerName: 'Tên khách hàng',
        customerCode: 'Mã khách hàng',
        customerID: 'ID khách hàng',
        rewardPoint: 'Điểm thưởng',
        role: 'Chức danh',
        province: 'Tỉnh/ Thành phố',
        district: 'Quận/ Huyện',
        ward: 'Phường/ Xã',
        birthday: 'Ngày sinh',
        name: 'Tên',
        address: 'Địa chỉ',
        holderSearchUser: 'Tìm kiếm theo tên, email, mã khách hàng hoặc số điện thoại',
        msgUserDoesNotExist: 'Người dùng không tồn tại trong hệ thống KiotViet'
    },
    promotion: {
        subject: 'Tiêu đề',
        content: 'Nội dung',
        author: 'Tác giả',
        sendDate: 'Ngày gửi',
        msgSendConfirm: 'Bạn có muốn gửi mẫu email này đi không?',
        msgDeleteEmail: 'Xóa email thành công',
        msgSendSuccess: 'Gửi email thành công',
        msgSendFailed: 'Gửi email thất bại',
        holderSearch: 'Tỉm kiếm email theo tiêu đề hoặc tên tác giả',
        msgSubjectRequired: 'Tiêu đề không được trống',
        msgContentRequired: 'Nội dung không được trống'
    },
    paymentMethod: {
        bankName: 'Tên tài khoản: {{value}}',
        bankNumber: 'Số tài khoản: {{value}}',
        bankInfo: 'Thông tin tài khoản: {{value}}',
        selectBank: 'Chọn số tài khoản:',
        transferContent: 'Nội dung chuyển khoản:',
        cashContent: 'Thanh toán trực tiếp cho nhân viên giao hàng',
        cash: 'Thanh toán khi nhận hàng',
        transfer: 'Chuyển khoản qua ngân hàng',
        deliveryMethod: 'Phương thức vận chuyển:',
        otherPolicy: 'Chính sách đổi hàng đối với khách hàng tỉnh',
        receiveTime: 'Thời gian giao/ nhận hàng'
    },
    policy: {
        txtStore: 'BILLION GIRL',
        txtStoreContact: 'Liên hệ: 0901235238',
        txtStoreAddress:
            'HCM: 780/10 Sư Vạn Hạnh P12 Q10 | HN: Lầu 3 , 82 Nguyễn Lương Bằng , Đống Đa , Hà Nội',
        txtPayment7: 'Nội dung chuyển khoản:',
        txtPayment8: '1 - Tên',
        txtPayment9: '2 - Số điện thoại',
        txtReadMore: 'Đọc thêm tại: ',
        shoppingGuideContent:
            '<p><strong>Mua sắm tại BILLIONGIRL thật dễ dàng. Quý khách chỉ cần làm theo các bước sau:</strong></p><ol><li>Chọn loại sản phẩm (đầm, váy, blazer, jean, v.v.).</li><li>Xem sản phẩm quý khách quan tâm rồi nhấp vào ảnh để phóng to và xem mọi chi tiết, kích cỡ hiện có, màu sắc và giá.</li><li>Chọn mặt hàng quần áo và thêm mặt hàng vào giỏ. Sau đó, quý khách có thể chọn tiếp tục mua sắm hoặc xử lý đơn hàng.</li><li>Nếu muốn xử lý đơn hàng, quý khách có thể thực hiện bằng cách đăng ký hoặc thanh toán với tư cách khách.</li><li>Chọn phương thức giao hàng.</li><li>Chọn phương thức thanh toán.</li><li>Xác nhận đơn hàng.</li><li>Quý khách sẽ nhận được email và cuộc gọi xác nhận đơn hàng.</li></ol>',
        paymentGuideContent1:
            '<p><strong>Tôi có thể sử dụng phương thức thanh toán nào để mua hàng?</strong></p><ul><li>Quý khách khi mua sắm tại www.billiongirl.vn có thể lựa chọn một trong các hình thức thanh toán sau để thuận tiện và nhanh nhất:</li><li>Quý khách mua hàng và thanh toán trực tiếp tại cửa hàng của www.billiongirl.vn</li><li>Thanh toán chuyển khoản: quý khách có thể chuyển khoản cho chúng tôi theo thông tin tài khoản sau:</li></ul>',
        paymentGuideContent2:
            '<p>**QUÝ KHÁCH VUI LÒNG CHUYỂN KHOẢN TRONG 24H GIỜ KỂ TỪ LÚC ĐẶT ĐƠN HÀNG ĐỂ ĐƯỢC XÁC NHẬN ĐƠN HÀNG, SAU 48 GIỜ BILLIONGIRL CHƯA NHẬN ĐƯỢC TIỀN SẼ TIẾN HÀNH HỦY ĐƠN ĐẶT HÀNG**</p><p>Ngay sau khi nhận được thanh toán của khách hàng qua chuyển khoản, chúng tôi sẽ xác nhận thông tin đơn hàng cho quý khách và hỗ trợ giải quyết giao hàng theo thỏa thuận hợp đồng hoặc theo thỏa thuận trực tiếp với khách hàng.</p><p>Thanh toán khi hàng được vận chuyển đến nhà (COD).</p>',
        deliveryGuideContent:
            '<p><strong>Tôi có thể nhận được đơn hàng ở đâu?</strong></p><p>Đơn hàng có thể được gửi tới địa chỉ do quý khách chọn (nhà riêng, cơ quan, v.v. - không phải là Hòm thư bưu điện).</p><p><strong>Mất bao lâu thì đơn hàng của tôi sẽ đến?</strong></p><p>Thông thường www.billiongirl.vn sẽ xác nhận đơn đặt hàng trong vòng 24h làm việc và tiến hành giao hàng cho khách hàng trong khoảng 03 ngày làm việc đối với khách nội thành và 07 ngày đối với khách ở tỉnh khác kể từ khi xác nhận đơn hàng với khách. Tuy nhiên, cũng có trường hợp việc giao hàng kéo dài hơn vài ngày làm việc, nhưng chỉ xảy ra trong những tình huống bất khả kháng như sau:</p><ul><li>Nhân viên www.billiongirl.vn liên lạc với khách hàng qua điện thoại không được nên không thể giao hàng.</li><li>Địa chỉ giao hàng bạn cung cấp không chính xác hoặc khó tìm.</li><li>Số lượng đơn hàng của www.billiongirl.vn tăng đột biến khiến việc xử lý đơn hàng bị chậm.</li><li>Đối tác cung cấp hàng cho www.billiongirl.vn chậm hơn dự kiến khiến việc giao hàng bị chậm lại hoặc đối tác vận chuyển giao hàng bị chậm.</li></ul><p><strong>Tôi phải trả bao nhiêu tiền cho dịch vụ giao hàng?</strong></p><p>Mức phí cho dịch vụ giao hàng là 30.000 đồng cho tất cả khu vực (Riêng khách Diamond sẽ là miễn phí).</p><p>MIỄN PHÍ chi phí giao hàng cho đơn hàng được thực hiện bởi tài khoản khách hàng DIAMOND.</p><p><strong>Tôi có thể theo dõi đơn hàng của mình không?</strong></p><p>Có, quý khách có thể xem trạng thái cập nhật của đơn hàng tại bất kỳ thời điểm nào. Để thực hiện điều này, hãy chuyển tới phần "Lịch sử mua hàng" trong tài khoản của quý khách.</p><p><strong>Quy trình giao hàng tại nhà là gì?</strong></p><p>Nếu quý khách chọn giao hàng tại nhà, chúng tôi sẽ gửi cho quý khách một email xác nhận rằng mặt hàng đã được xác nhận, sau đó nhân viên chuyển phát sẽ thông báo về việc giao hàng cho quý khách.</p>',
        commonQuestion:
            '<p><strong>Chúng tôi bán hàng trực tuyến tại những nơi nào?</strong></p><p>Quý khách hiện có thể mua sắm trực tuyến trên toàn bộ lãnh thổ Việt Nam.</p><p><strong>Có thể xem trang web bằng bao nhiêu ngôn ngữ?</strong></p><p>Có 2 tùy chọn ngôn ngữ để xem trang BILLIONGIRL là: Tiếng Việt và Tiếng Anh</p><p><strong>Giá trên cửa hàng trực tuyến có giống với giá trong cửa hàng thông thường của BILLIONGIRL không?</strong></p><p>Có, tuy nhiên, nếu có sự khác biệt giữa giá hiển thị trên trang web và giá trên tem nhãn sản phẩm, thì giá chính xác sẽ là giá hiển thị trên hóa đơn mua hàng.</p><p><strong>Tôi có nhận được sản phẩm tương tự như trong ảnh không?</strong></p><p>Có, ảnh trên trang BILLIONGIRL hoàn toàn tự chụp nên sản phẩm bạn nhận được sẽ hoàn toàn giống trong ảnh.</p><p><strong>Có thể nhận thông tin theo định kỳ qua email về các sản phẩm và ưu đãi mới nhất của BILLIONGIRL không?</strong></p><p>Có. Chỉ cần cung cấp email quý khách ở mục đăng ký nhận bản tin, quý khách sẽ nhận được thông tin về các sản phẩm, bộ sưu tập và sự kiện mới nhất của BILLIONGIRL qua email.</p><p><strong>Làm cách nào để khôi phục mật khẩu mà tôi đã quên?</strong></p><p>Nếu quên mật khẩu, quý khách có thể khôi phục mật khẩu trong phần Đăng nhập. Nhập địa chỉ email và chúng tôi sẽ gửi cho quý khách email cho biết những gì quý khách cần thực hiện.</p><p><strong>Làm cách làm tôi có thể chắc chắn rằng mình đã mua hàng đúng cách?</strong></p><p>Sau khi đặt hàng, quý khách sẽ nhận được email và cuộc gọi xác nhận. Nếu không nhận được email và cuộc gọi, hãy liên hệ với dịch vụ khách hàng của chúng tôi.</p><p><strong>Tôi có thể theo dõi đơn hàng của mình không?</strong></p><p>Có, quý khách có thể xem trạng thái cập nhật của đơn hàng tại bất kỳ thời điểm nào. Để thực hiện điều này, hãy chuyển tới phần "Lịch sử đặt hàng" trong tài khoản của quý khách.</p><p>Nếu quý khách chưa đăng ký, hãy nhấp vào liên kết "Thông tin đơn hàng" trong email xác nhận được gửi cho quý khách.</p><p><strong>Tôi có thể xóa mặt hàng khỏi đơn hàng của mình không?</strong></p><p>Có. Quý khách có thể xóa mọi mặt hàng không mong muốn khỏi giỏ hàng của mình, miễn là đơn hàng đó chưa được xử lý.</p><p><strong>Tôi có thể hủy đơn hàng không?</strong></p><p>Có. Quý khách có thể hủy đơn hàng, miễn là trạng thái của đơn hàng vẫn còn trong trạng thái đang chờ. Để thực hiện điều này, hãy liên lạc đến tổng đài hỗ trợ khách hàng qua số 0901235238.</p><p><strong>Tôi nên làm gì nếu nhận được hàng lỗi hoặc nhận được món hàng không phải món hàng đã đặt?</strong></p><p>BILLIONGIRL chỉ bán các mặt hàng trong tình trạng hoàn hảo và sẽ kiểm tra kỹ càng đơn hàng trước khi giao cho vận chuyển, vì vậy, trong trường hợp hiếm gặp khi nhận được hàng lỗi hoặc sai món hàng đã đặt, vui lòng liên hệ với dịch vụ khách hàng của chúng tôi.</p>',
        returnPolicyContent:
            '<p>Hoá đơn mua hàng hoặc hoá đơn thẻ tín dụng phải cung cấp khi đổi hàng.</p><p>Sản phẩm còn nguyên tem mác và chưa qua sử dụng.</p><p>Thời hạn thực hiện đổi trả trong vòng 7 ngày kể từ ngày nhận hàng.</p><p>Quý khách chỉ được đổi 1 lần cho 1 hoá đơn mua hàng.</p><p>1. Trường hợp được áp dụng:</p><ul><li>Quý khách được đổi size trên cùng 1 sản phẩm và 1 màu. Nếu sản phẩm hết size quý khách được đổi sang sản phẩm khác.</li><li>Quý khách được đổi sản phẩm khi bị lỗi do vận chuyển, bị lỗi do sản xuất, bị lỗi do kĩ thuật.</li></ul><p>2. Trường hợp không được áp dụng:</p><ul><li>Các sản phẩm bị ám mùi lạ như mùi nước hoa, nước xả vải, nước giặt v.v… khi đã qua sử dụng.</li><li>Các sản phẩm làm mất form ngay lần mặc do BillionGirl qui định, phụ kiện và đồ lót.</li><li>Các sản phẩm từ chương trình giảm giá hoặc từ cửa hàng Outlet.</li><li>Các sản phẩm không nằm trên điều kiện được đổi hàng.</li></ul>',
        returnGuideContent:
            '<p><strong>Bước 1: Xác nhận tình trạng hàng đổi</strong></p><ul><li>Nếu sản phẩm thuộc các trường hợp lỗi, khách hàng tiến hành chụp hình hiện trạng của sản phẩm. Sau đó liên hệ trực tiếp bộ phận Chăm sóc Khánh hàng của Chúng tôi theo số điện thoại 0901235238 hoặc gửi hình ảnh và phản ánh về địa chỉ mail <strong>cskh.billiongirl.vn@gmail.com</strong> để thông báo thông tin và gửi hình ảnh đến chúng tôi để xác nhận.</li></ul><p><strong>Bước 2: Chúng tôi xác nhận</strong></p><ul><li>Chúng tôi sau khi nhận được thông tin sẽ tiến hành xác nhận tình trạng hàng hóa và xác nhận cho khách hàng là có được đổi hay không.</li><li>Sau khi được xác nhận hàng được chấp nhận đổi, vui lòng giữ hàng hóa trong trạng thái nguyên nhãn mác sản phẩm của Chúng tôi như ban đầu cùng Hoá đơn thanh toán, Hoá đơn nhận hàng.</li></ul><p><strong>Bước 3: Khách hàng gửi hàng</strong></p><ul><li>Quý khách gửi lại sản phẩm cùng các giấy tờ đã được nêu ở Bước 2 đến cho Chúng tôi theo địa chỉ: BILLIONGIRL ONLINE STORE | HCM - 780/10 Sư Vạn Hạnh P12 Q10, TP.Hồ Chí Minh | HN - Lầu 3 , 82 Nguyễn Lương Bằng , Đống Đa , Hà Nội – Điện thoại: 0901235238</li><li>Với Khách hàng ở Thành Phố Hồ Chí Minh cũng có thể đến đổi hàng trực tiếp tại tất cả cửa hàng thuộc hệ thống BILLIONGIRL.</li></ul><p><strong>Bước 4: Chúng tôi xác nhận và gửi hàng cho khách hàng</strong></p><ul><li>Sau khi đã nhận, kiểm tra và chấp nhận sản phẩm mà Quý khách muốn đổi, bộ phận chăm sóc khách hàng sẽ liên hệ để đổi hàng và gửi hàng lại cho Quý khách</li></ul><p><strong>Lưu ý : Người Mua Hàng sẽ phải chịu các chi phí phát sinh cho việc đổi hàng.</strong></p>',
        securityContent:
            '<p><strong>Mục đích và phạm vi thu thập</strong></p><ul><li>Việc thu thập dữ liệu chủ yếu trên website www.billiongirl.vn bao gồm: tên, email, điện thoại, địa chỉ khách hàng,…. Đây là các thông tin mà www.billiongirl.vn cần khách hàng cung cấp bắt buộc khi đăng ký sử dụng dịch vụ và để www.billiongirl.vn liên hệ xác nhận khi khách hàng có nhu cầu cần sự hỗ trợ cũng như tư vấn trên website nhằm đảm bảo quyền lợi cho cho người tiêu dùng.</li><li>Khách hàng sẽ tự chịu trách nhiệm về bảo mật và lưu giữ mọi hoạt động sử dụng dịch vụ tại hộp thư điện tử của mình. Ngoài ra, khách hàng có trách nhiệm thông báo kịp thời cho webiste www.billiongirl.vn về những hành vi sử dụng trái phép, lạm dụng, vi phạm bảo mật, lưu giữ thông tin liên hệ cho bên thứ ba để có biện pháp giải quyết phù hợp.</li></ul><p><strong>Phạm vi sử dụng thông tin</strong></p><p>Công ty sử dụng thông tin người dùng cung cấp để:</p><ul><li>Cung cấp các dịch vụ đến người mua;</li><li>Giao hàng theo địa chỉ mà người mua cung cấp;</li><li>Gửi email tiếp thị, khuyến mại về hàng hóa do chúng tôi bán;</li><li>Gửi các thông báo mới về mẫu mã sản phẩm cũng như các hoạt động mới đến khách hàng của website www.billiongirl.vn;</li><li>Liên lạc và giải quyết với khách hàng trong những trường hợp đặc biệt;</li><li>Không sử dụng thông tin cá nhân của khách hàng ngoài mục đích xác nhận và liên hệ có liên quan đến giao dịch tại www.billiongirl.vn;</li></ul><p><strong>Thời gian lưu trữ thông tin</strong></p><ul><li>Dữ liệu cá nhân của người dùng sẽ được lưu trữ trong suốt quá trình hợp tác giữa www.billiongirl.vn và khách hàng. Dữ liệu chỉ được hủy khi khách hàng chấm dứt hoàn toàn các hoạt động giao dịch với www.billiongirl.vn và có sự yêu cầu hủy lưu dữ thông tin liên hệ từ phía khách hàng.</li><li>Trong trường hợp người dùng muốn xóa toàn bộ thông tin về tài khoản đề nghị người dùng liên hệ với chúng tôi theo địa chỉ ở mục liên hệ</li></ul><p><strong>Địa chỉ của đơn vị thu thập và quản lý thông tin cá nhân</strong></p><ul><li>BILLIONGIRL</li><li>Địa chỉ: 115, Đường số 1, Phường 4, Quận 3, Tp.HCM</li><li>Điện thoại: 0986948883</li><li>Email: billiongirl.vn@gmail.com</li><li>Nếu khách hàng tin rằng chúng tôi đã cung cấp thông tin của mình cho bên thứ ba mà không được sự đồng ý của khách hàng, thì khách hàng có quyền khiếu nại đến chúng tôi theo địa chỉ ở trên. Công ty chúng tôi có nghĩa vụ giải quyết các vấn đề liên quan đến việc bảo mật thông tin khách hàng khi xem xét các bằng chứng người dùng cung cấp là có cơ sở.</li></ul><p><strong>Phương tiện và công cụ để người dùng tiếp cận và chỉnh sửa dữ liệu cá nhân của mình.</strong></p><ul><li>Khách hàng có quyền tự kiểm tra, cập nhật, điều chỉnh hoặc hủy bỏ thông tin cá nhân của mình bằng cách gửi thông tin cần chỉnh sửa vào email: billiongirl.vn@gmail.com</li><li>Chúng tôi sẽ hỗ trợ người dùng về mặt kỹ thuật để chỉnh sửa thông tin nếu nhận được yêu cầu từ phía người dùng.</li></ul><p><strong>Cam kết bảo mật thông tin cá nhân khách hàng</strong></p><ul><li>Thông tin cá nhân của khách hàng trên www.billiongirl.vn được www.billiongirl.vn cam kết bảo mật tuyệt đối theo chính sách bảo vệ thông tin cá nhân của www.billiongirl.vn. Việc thu thập và sử dụng thông tin của mỗi khách hàng chỉ được thực hiện khi có sự đồng ý của khách hàng đó trừ những trường hợp pháp luật có quy định khác.</li><li>Không sử dụng, không chuyển giao, cung cấp hay tiết lộ cho bên thứ 3 nào về thông tin cá nhân của khách hàng khi không có sự cho phép đồng ý từ khách hàng.</li><li>Chúng tôi sẽ cung cấp 1 số thông tin như: tên, địa chỉ, số điện thoại cho bên dịch vụ vận chuyển khi sử dụng dịch vụ giao nhận vận chuyển.</li><li>Trong trường hợp máy chủ lưu trữ thông tin bị hacker tấn công dẫn đến mất mát dữ liệu cá nhân khách hàng, www.billiongirl.vn sẽ có trách nhiệm thông báo vụ việc cho cơ quan chức năng điều tra xử lý kịp thời đồng thời chúng tôi cũng sẽ thông báo đến cho khách hàng.</li><li>Ban quản lý www.billiongirl.vn yêu cầu các khách hàng khi mua hàng phải cung cấp đầy đủ thông tin cá nhân có liên quan như: Họ và tên, địa chỉ liên lạc, email, số chứng minh nhân dân, điện thoại, …, và chịu trách nhiệm về tính pháp lý của những thông tin trên. Ban quản lý www.billiongirl.vn không chịu trách nhiệm cũng như không giải quyết mọi khiếu nại có liên quan đến quyền lợi của khách hàng đó nếu xét thấy tất cả thông tin cá nhân của khách hàng đó cung cấp khi đăng ký ban đầu là không chính xác.</li></ul>',
        deliveryPolicyContent:
            '<p><strong>Phương thức vận chuyển giao hàng:</strong></p><ul><li>Đối với Khách Hàng ở thành phố Hồ Chí Minh : Chúng tôi sẽ giao hàng hoá/sản phẩm cho Quý Khách qua Người giao hàng ( Shipper ) hoặc qua Công ty Chuyển Phát Nhanh tuỳ thoả thuận theo THÔNG TIN NGƯỜI NHẬN HÀNG mà Quý khách đã cung cấp khi đặt hàng.</li><li>Đối với Khách Hàng ở các tỉnh thành Khác : Chúng tôi sẽ giao hàng hóa/sản phẩm cho quý khách qua Công ty Chuyển Phát Nhanh theo THÔNG TIN NGƯỜI NHẬN HÀNG mà Quý khách đã cung cấp khi đặt hàng.</li></ul><p><strong>Thời gian giao/nhận hàng::</strong></p><ul><li>Đối với Khách Hàng ở thành phố Hồ Chí Minh: Từ 2 đến 3 ngày sau khi đơn hàng được xác nhận (không kể thứ 7 chủ nhật ).</li><li>Đối với Khách Hàng ở các tỉnh thành Khác : Từ 3 đến 7 ngày sau khi đơn hàng được xác nhận (không kể thứ 7 chủ nhật ).</li><li>Trường hợp quá hạn giao/nhận hàng : Quý khách vui lòng thông báo đến Bộ Phận Chăm sóc khách hàng của chúng tôi theo số điện thoại 0901235238 hoặc địa chỉ mail : cskh.billiongirl.vn@gmail.com để được hỗ trợ.</li></ul><p><strong>Phí vận chuyển:</strong></p><ul><li>Đối với Khách Hàng ở thành phố Hồ Chí Minh : 30.000 vnđ/ 1 lần giao hàng nhanh</li><li>Đối với Khách Hàng ở các tỉnh thành Khác : 30.000 vnđ/ 1 lần giao hàng tiêu chuẩn. 45.000 vnđ/ 1 lần giao hàng nhanh</li><li>Đối với các đơn hàng được thực hiện bởi khách hàng DIAMOND: Miễn phí giao hàng</li></ul>',
        rewardPolicyContent:
            ' <p>Billion Girl xin gửi đến các Nàng - quý khách hàng thân mến Thông báo về việc “Từ 01.09.2022 Billion Girl chính thức THAY ĐỔI &amp; ÁP DỤNG CHƯƠNG TRÌNH TÍCH LUỸ ĐIỂM MUA SẮM MỚI TẠI BILLION GIRL”</p><p><strong>A. Từ ngày 01.09.2022, hệ thống dịch vụ của chúng tôi áp dụng chương trình tích lũy theo 3 hạng mục khách hàng:</strong></p><p>1. Khách tiêu chuẩn - Standard:</p><ul><li>Điều kiện tham gia: Khách hàng có chi tiêu từ 1 VND đến 9.999.999 VND (trừ đổi trả) tại hệ thống Billion Girl.</li><li>Quyền lợi: được sử dụng các dịch vụ mua - đổi trả theo quy định, nhận ưu đãi trong tháng sinh nhật, nhận các ưu đãi trực tiếp từ thương hiệu.</li></ul><p>2. Khách hạng vàng - Gold:</p><ul><li>Điều kiện tham gia: Khách hàng có chi tiêu từ 10.000.000 VND đến 24.999.999 VND (trừ đổi trả) tại hệ thống Billion Girl.</li><li>Quyền lợi: Khách hàng được áp dụng giảm giá cố định 10% và duy trì ưu đãi vĩnh viễn, không giới hạn, không hết hạn, không yêu cầu duy trì chi tiêu số lần/ khoảng thời gian. Khách hàng được sử dụng các dịch vụ mua - đổi trả theo quy định, nhận ưu đãi trong tháng sinh nhật, nhận các ưu đãi trực tiếp từ thương hiệu.</li></ul><p>3. Khách hạng kim cương Diamond:&nbsp;</p><ul><li>Điều kiện tham gia: Khách hàng có chi tiêu từ 25.000.000 VND (trừ đổi trả) tại hệ thống Billion Girl.&nbsp;</li><li>Quyền lợi: Khách hàng được áp dụng giảm giá cố định 15%, miễn phí vận chuyển 1 chiều đối với đơn hàng mua mới và duy trì ưu đãi vĩnh viễn, không giới hạn, không hết hạn, không yêu cầu duy trì chi tiêu số lần/ khoảng thời gian. Khách hàng được sử dụng các dịch vụ mua - đổi trả theo quy định, nhận ưu đãi trong tháng sinh nhật, nhận các ưu đãi trực tiếp từ thương hiệu.</li></ul><p><strong>B. Đối với các khách hàng hạng VIP theo Chương trình tích lũy trước ngày 01.09.2022</strong></p><ul><li>Khách hàng hạng VIP theo Chương trình cũ sẽ được nâng trực tiếp lên hạng DIAMOND theo chương trình mới (Chú thích: VIP cũ có chi tiêu trên 10.000.000 VND trừ đổi trả)</li><li>Khách hàng có chi tiêu gần hạng VIP sẽ nhận được các thông báo, hỗ trợ từ đội ngũ Chăm sóc khách hàng để có thể bảo đảm quyền lợi một cách tốt nhất.</li></ul><p><br></p><p>BILLION GIRL XIN CHÂN THÀNH CẢM ƠN!</p>'
    },
    agree: 'Tôi đã đọc và đồng ý CHÍNH SÁCH ĐỔI HÀNG VÀ VẬN CHUYỂN HÀNG',
    btnFinish: 'Hoàn thành',
    btnNex: 'Tiếp',
    btnSyncProduct: 'Đồng độ dữ liệu',
    btnSyncLoyalty: 'Đồng độ loyalty',
    btnPrevious: 'Trở lại',
    stepShipping: 'Giao Hàng',
    stepPayment: 'Thanh Toán',
    stepFinish: 'Hoàn Thành',
    btnBackToShop: 'Trang chủ',
    btnContinues: 'Tiếp tục',
    btnFilter: 'Lọc',
    btnExplore: 'Khám phá',
    btnShopNow: 'Mua Ngay',
    btnCheckOut: 'Thanh toán',
    btnQuickBuy: 'Mua nhanh',
    btnAddToCart: 'Thêm vào giỏ hàng',
    btnOutOfStock: 'Hết Hàng',
    msgSelectSize: 'Vui lòng chọn size',
    msgOutOfQuantity: 'Sản phẩm bạn vừa mua đã vượt quá tồn kho',
    msgOutOfQuantityOnCart: 'Sản phẩm bạn vừa mua đã tồn tại trong giỏ hàng và vượt quá tồn kho',
    msgNotFound: 'Không có dữ liệu',
    btnLoadMore: 'Tải Thêm Ảnh',
    btnChangeImage: 'Thay đổi ảnh',
    btnAction: 'Thao tác',
    btnNew: 'Tạo mới',
    btnDelete: 'Xóa',
    btnEdit: 'Chỉnh sửa',
    btnClone: 'Sao chép',
    btnCreate: 'Tạo mới',
    btnUpdate: 'Cập nhật',
    btnSendEmail: 'Gửi mẫu email',
    btnBack: 'Trở lại',
    msgDelete: 'Bạn có chắc muốn xóa mục đã chọn?',
    titleProductManagement: 'Sản phẩm',
    titleSystemManagement: 'Hệ thống',
    titleColorManagement: 'Màu',
    titleSizeManagement: 'Size',
    titleSizeGuideManagement: 'Size guide',
    titleCategoryManagement: 'Category',
    titleImageManagement: 'Hình Ảnh',
    titleDiscountManagement: 'Giảm giá',
    titleUserManagement: 'Khách hàng',
    titleOrderManagement: 'Đơn hàng',
    titleHistoryManagement: 'Lịch sử thao tác',
    titleLayoutManagement: 'Dàn trang',
    titleFollowerManagement: 'Người theo dõi',
    titleLogout: 'Đăng xuất',
    titleChangePassword: 'Đổi mật khẩu',
    titleProduct: 'Sản phẩm',
    titleCustomerManagement: 'Khách hàng',
    titleInvoiceManagement: 'Hóa Đơn',
    titlePromotionManagement: 'Gửi email',
    titleReturnManagement: 'Trả hàng',
    titleHomepageSettingManagement: 'Cài đặt trang chủ',
    titleBankManagement: 'Tài khoản ngân hàng',
    txtPassword: 'Mật khẩu!',
    txtEmail: 'Email',
    txtGoToLogin: 'Đến trang đăng nhập',
    txtGoToHome: 'Đến trang chủ',
    txtFailed: 'Thất bại',
    txtChangePassword: ' Đổi mật khẩu',
    txtSentMailInfo: 'Một email vừa được gửi đến {{email}}',
    txtCheckGuide: 'Vui lòng kiểm tra hòm thư và làm theo hướng dẫn.',
    txtForgotPass: 'Quên mật khẩu',
    txtConfirmResetEmail: 'Xác nhận email của bạn để tạo lại mật khẩu',
    txtConfirmResetPhone: 'Xác nhận số điện thoại của bạn để tạo lại mật khẩu',
    textInputNameRequired: 'Vui lòng nhập tên',
    txtInputEmailRequired: 'Vui lòng nhập email',
    textInputPhoneRequired: 'Vui lòng nhập số điện thoại',
    txtInputCurrentPassword: 'Vui lòng nhập mật khẩu hiện tại',
    txtInputNewPasswordRequired: 'Vui lòng nhập mật khẩu mới',
    txtInputConfirmPasswordRequired: 'Vui lòng nhập lại mật khẩu',
    txtFromDate: 'Từ ngày',
    txtToDate: 'Đến ngày',
    txtStatus: 'Trạng thái',
    txtBPCode: 'Mã BP',
    txtFullName: 'Họ và tên',
    txtPhone: 'Số điện thoại',
    txtDob: 'Ngày sinh',
    txtAddress: 'Địa chỉ',
    txtUpdateDate: 'Ngày cập nhật',
    placeRequirePassword: 'Vui lòng nhập mật khẩu',
    btnForgotPassword: 'Quên mật khẩu?',
    btnLogin: 'Đăng nhập',
    btnRegister: 'Đăng ký',
    btnConfirm: 'Xác nhận',
    btnSendRequest: 'Gửi yêu cầu',
    btnSave: 'Lưu',
    btnSync: 'Đồng Bộ',
    btnSaveAndSend: 'Lưu & Gửi',
    btnCancel: 'Hủy',
    btnClose: 'Đóng',
    btnOK: 'OK',
    btnPay: 'Thanh Toán',
    btnShopping: 'Mua sắm',
    msgSystemError: 'Lỗi hệ thống, vui lòng thử lại sau',
    msgTokenNotExist: 'Token không tồn tại, vui lòng thực hiện lại!',
    msgTokenWrongFormat: 'Token không hợp lệ, vui lòng thực hiện lại!',
    msgTokenExpire: 'Token đã hết hạn, vui lòng thực hiện lại!',
    msgSamePassword: 'Mật khẩu trùng với mật khẩu cũ!',
    msgChangePasswordSuccess: 'Đổi mật khẩu thành công',
    msgPasswordRequired: 'Bạn cần phải tạo mật khẩu mới trước khi sử dụng',
    msgSendEmailFailed: 'Gửi email không thành công!',
    msgEmailNotExist: 'Email không tồn tại!',
    msgPhoneNotExist: 'Số điện thoại không tồn tại!',
    msgUserNotExist: 'Khách hàng không tồn tại trong hệ thống',
    msgEmailExisted: 'Email đã tồn tại trong hệ thống',
    msgPhoneExisted: 'Số điện thoại đã tồn tại trong hệ thống',
    msgWrongPassWord: 'Sai mật khẩu',
    msgSentRequestSuccess: 'Đã gửi yêu cầu',
    msgSentRequestFailed: 'Gửi yêu cầu thất bại',
    msgUpdatePasswordSuccess: 'Đã cập nhật mật khẩu thành công',
    msgWrongLoginPassword: 'Mật khẩu hiện tại không đúng!',
    msgLogoutConfirm: 'Bạn có thật sự muốn đăng xuất?',
    msgValidateName: 'Tên chứa tối thiểu {{min}} ký tự và tối đa {{max}} ký tự',
    msgWarningSyncBackground: 'Dữ liệu của bạn đang được đồng bộ bên dưới',
    txtPaginationContent: 'Hiển thị {{startRange}} - {{endRange}}/{{total}}',
    titleSuggestion: 'Đề xuất',
    sync100: 'Đồng bộ 100 bản ghi mới nhất',
    sync200: 'Đồng bộ 100 bản ghi mới nhất',
    sync500: 'Đồng bộ 100 bản ghi mới nhất',
    sync1000: 'Đồng bộ 100 bản ghi mới nhất',
    syncAll: 'Đồng bộ tất cả bản ghi',
    btnReload: 'Tải lại',
    btnSubmit: 'Gửi',
    btnBackToHome: 'Trở về trang chủ',
    btnReset: 'Đặt lại',
    systemContactNumber: '0901235238'
};

export default vi;
